import { isWorkSectionKey, type WorkSectionKey } from '@/api/work';
import { humanize } from '@/ui/vocabulary';

import { OPERATIONS_PLANS } from './operationsPlans';
import { fallbackRow } from './planParts';
import type { SectionPlan } from './planTypes';
import { SALES_PLANS } from './salesPlans';

// Typed on the contract's keys, so a section the server gains is a compile error until it is worded.
const PLANS: Readonly<Record<WorkSectionKey, SectionPlan>> = {
  ...SALES_PLANS,
  ...OPERATIONS_PLANS,
};

/**
 * How Today words and links one section.
 *
 * A section a newer server adds is not dropped: it gets a heading made from its code and a plain
 * row for each item, so the work is visible until someone words it properly.
 *
 * @param key the section's key from the server
 * @returns the plan for that section
 */
export function planFor(key: string): SectionPlan {
  if (isWorkSectionKey(key)) {
    return PLANS[key];
  }
  return { title: humanize(key), seeAllTo: () => null, row: fallbackRow };
}
